import { z } from "zod";

// Canonical click action values from shared_constants.json FLEXIBLE_ON_CLICK,
// codified in shared_code/app/models/shared/appboy/communication/flexible_on_click.rb.
// OPEN_APP is excluded: it is API-only and converted to NONE on the backend.
export const clickActionSchema = z.enum([
  "URI",
  "DEEP_LINK",
  "NONE",
  "CLOSE",
  "LOG_CUSTOM_EVENT",
  "LOG_CUSTOM_ATTRIBUTE",
  "SHOW_PUSH_PROMPT",
]);
